import { useEffect, useState } from 'react'
import WifiOffIcon from '@mui/icons-material/WifiOff'
import WifiIcon from '@mui/icons-material/Wifi'
import CircleIcon from '@mui/icons-material/Circle'
import { Box } from '@mui/system'
import { Typography } from '@mui/material'
import { OnlineStatusColors } from 'constant/color'

function WifiStatus() {
    const [online, setOnline] = useState<boolean>(navigator.onLine)

    useEffect(() => {
        const makeOffline = () => {
            setOnline(false)
        }

        const makeOnline = () => {
            setOnline(true)
        }
        window.addEventListener('online', makeOnline)
        window.addEventListener('offline', makeOffline)
        return () => {
            window.removeEventListener('online', makeOnline)
            window.removeEventListener('offline', makeOffline)
        }
    }, [])
    return (
        <Box
            sx={{
                color: '#ffff',
                display: 'flex',
                float: 'right',
                mt: 1,
                mr: 1,
            }}
        >
            <CircleIcon
                fontSize="small"
                sx={{
                    color: online
                        ? OnlineStatusColors.Online
                        : OnlineStatusColors.Offlne,
                    alignSelf: 'center',
                    pr: 1,
                }}
            />
            <Typography
                sx={{
                    pr: 1,
                }}
            >
                {online ? 'Online' : 'Offline'}
            </Typography>
            {online ? <WifiIcon /> : <WifiOffIcon />}
        </Box>
    )
}

export default WifiStatus
